$(document).ready(()=>{
  toggleMenu()
  checkCookie()
  hideActu()
});

const toggleMenu = () => {
  $('.toggle_nav').on('click', (e) => {
    $(e.currentTarget).toggleClass('is-open')
    $('#main-menu ul').toggleClass('is-open')
    $('body').toggleClass('overlow-hidden')
  })
}

const hideActu = () => {
  $('.close_actu').on('click', () => {
    $("#actus").slideUp();
    setCookie('actu', "hide", 1)
  })
}



const setCookie = (cname, cvalue, exdays) => {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

const getCookie = (cname) => {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const checkCookie = () => {
  var user = getCookie("actu");
  if (user != "hide") {
    $("#actus").show();
  }
}